module.exports = __webpack_public_path__ + "img/clock.4f2144f0.svg";